import prototype from "../../../../attached_assets/employees-full-flow_1791573215470.html?raw";
import { staffText } from "@/lib/staff-language";
import { staffFinishingText } from "./staff-finishing-language";

// Read only the approved translation dictionary. Never execute prototype scripts.
const source=prototype.match(/const AR=(\{[^\n]+\});/);
// Runtime grouping labels not present as standalone strings in the prototype.
// Its existing approved translations always win.
const approved:Record<string,string>={"Pay held · stopped coming":"الصرف موقوف · منقطعون عن العمل","Pay held":"الصرف موقوف","Held":"موقوف","Stopped coming":"منقطع عن العمل","Stopped coming · {0} days":"منقطع عن العمل · {0} يومًا","only what you fill in changes":"لا يتغير إلا ما تملؤه","Or paste from Excel":"أو الصق من Excel","Pasted rows":"صفوف ملصقة","Check before saving":"راجع قبل الحفظ","Pay changes":"تغييرات الرواتب","Nothing waits for approval":"لا شيء ينتظر موافقة","required":"مطلوب","PAY":"صرف","Open card":"فتح البطاقة","Hire date is missing":"ينقصه تاريخ التعيين","{0} payment to {1} people":"{0} دفعة لـ{1} موظف","{0} payments to {1} people":"{0} دفعات لـ{1} موظف",...(source?JSON.parse(source[1]):{})};
const templates=Object.entries(approved).filter(([key])=>/\{\d+\}/.test(key)).sort(([a],[b])=>b.replace(/\{\d+\}/g,"").length-a.replace(/\{\d+\}/g,"").length);
// The approved dictionary prefixes these labels with an icon; the live labels omit it.
const positionScopeLabels:Record<string,string>={
  "All branches · finance edits it":"لكل الفروع · تعدّله المالية",
  "Another branch's position":"مسمى لفرع آخر",
};
export function step10Text(value:string,rtl:boolean):string {
  if(!rtl)return value;
  if(approved[value])return approved[value];
  // Complete operational sentences must win over generic "{0}" templates.
  // Use the existing formatter so dates captured in those sentences stay Arabic.
  if(staffFinishingText(value))return staffText(value,rtl);
  if(positionScopeLabels[value])return positionScopeLabels[value];
  for(const [pattern,translation] of templates){
    const escaped=pattern.replace(/[.*+?^${}()|[\]\\]/g,"\\$&").replace(/\\\{(\d+)\\\}/g,"(.+?)");
    const match=value.match(new RegExp(`^${escaped}$`));
    if(match&&pattern.replace(/\{\d+\}/g,"").length>3)return translation.replace(/\{(\d+)\}/g,(_,n)=>step10Text(match[Number(n)+1]||"",rtl));
  }
  return staffText(value,rtl);
}
